import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-clins',
  templateUrl: './clins.component.html',
  styleUrls: ['./clins.component.css']
})

export class ClinsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.CLINS.columns;
    this.data = this.report.CLINS.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.CLINS.data;
    const gridInstance = this.gridContext.getInstance('CLINS');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/clins/clins.component.ts